var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.759 5.946H3.24a.241.241 0 0 1-.24-.24V4.74c0-.133.108-.241.241-.241H20.76c.133 0 .241.108.241.241v.964a.241.241 0 0 1-.241.241zm0 6.429H3.24a.241.241 0 0 1-.24-.241v-.964c0-.133.108-.241.241-.241H20.76a.24.24 0 0 1 .241.24v.965a.241.241 0 0 1-.241.241zm0 6.429H3.24a.241.241 0 0 1-.24-.241v-.965a.24.24 0 0 1 .241-.24H20.76a.24.24 0 0 1 .241.24v.965a.241.241 0 0 1-.241.24z",
    fill: "currentColor"
  })));
};

export default SvgMenu;